import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UploadPage from "./page/UploadSection";
import ReportPage from "./page/ReportPage";
import ThemeWrapper from "./theme/ThemeWrapper";
import LoginPage from "./page/LoginPage";
import { CameraStatusProvider } from "./components/context/CameraStatusContext";
import ArchivePage from "./page/ArchivePage";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeWrapper>
          <CameraStatusProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/" element={<App />} />
              <Route path="/upload" element={<UploadPage />} />
              <Route path="/reports" element={<ReportPage />} />
              <Route path="/archive" element={<ArchivePage />} />

            </Routes>
          </CameraStatusProvider>
        </ThemeWrapper>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
